import React, { useEffect } from "react";
import NavBar from "../Navigation/NavBar";
import Footer from "../Footer/Footer";
import "./Agreements.css";

function Privacypolicy() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <NavBar />
      <div className="MainPolicy">
        <h1 className="Ptecs">Privacy Policy</h1>
        <div>
          <h2 className="Hedingsa">Introduction</h2>
          <p className="SetSubteag">
            Welcome to https://quarec.com (Quarec Resources Pvt. Ltd.). We are
            committed to protecting your privacy and ensuring the security of
            your personal information. This Privacy Policy outlines how we
            collect, use, disclose, and protect the data you provide while using
            our website.
          </p>
          <h2 className="Hedingsa">Information We Collect</h2>
            <p className="SetSubteag">
              When you use our website, we may collect information you submit in
              contact, newsletter, and job application forms. This may include
              your name, email address, phone number, message, employment
              experience, compensation details, portfolio URL, and resume. Please
              do not submit information that is not needed for your enquiry or
              application.
            </p>
        </div>
        <h2 className="Hedingsa">Use of Information</h2>
        <p className="SetSubteag">
          We may use the collected information for the following purposes:
        </p>
        <p className="SetSubteag2">
          <b className="Enterbold">A. </b>To operate and improve the website
          and understand how visitors use it.
        </p>
        <p className="SetSubteag2">
          <b className="Enterbold">B. </b>To process and respond to your
          inquiries, requests, or comments.
        </p>
          <p className="SetSubteag2">
            <b className="Enterbold">C. </b>To review and respond to job applications and enquiries, and to send
            newsletter communications where you have subscribed.
          </p>
        <p className="SetSubteag2">
          <b className="Enterbold">D. </b>To protect the website, meet legal
          obligations, and resolve disputes.
        </p>
        <h2 className="Hedingsa">Cookies and Tracking Technologies</h2>
          <p className="SetSubteag">
            This website uses Google Analytics to measure visits and understand
            how visitors use the site. Google Analytics may use cookies or similar
            technologies to collect information such as browser and device
            details, pages visited, and interactions. You can manage cookies in
            your browser settings. More information about Google's data practices
            is available at <a href="https://policies.google.com/technologies/partner-sites">How Google uses information from sites or apps that use its services</a>.
          </p>
          <p className="SetSubteag">
            If Google AdSense advertising is enabled on this website, Google and
            its advertising partners may use cookies or similar technologies to
            serve, measure, and, where permitted, personalize ads. You can manage
            Google's ad personalization settings through <a href="https://myadcenter.google.com/">My Ad Center</a> and learn more in Google's
            <a href="https://policies.google.com/technologies/ads"> advertising privacy information</a>. Browser cookie controls are also available; disabling cookies may affect some site features.
          </p>
        <h2 className="Hedingsa">Third-Party Disclosure</h2>
        <p className="SetSubteag">
            We may disclose information to service providers that support website
            hosting, form processing, analytics, and advertising (if enabled), as
            well as when required by law or necessary to protect our rights. These
            providers process information under their own privacy terms and our
            applicable arrangements with them.
        </p>
        <h2 className="Hedingsa">Data Security</h2>
        <p className="SetSubteag">
          We implement reasonable technical and organizational measures to
          protect your personal data from unauthorized access, disclosure,
          alteration, or destruction. While we strive to safeguard your
          information, no data transmission over the internet is entirely
          secure. Therefore, we cannot guarantee the absolute security of your
          data.
        </p>
        <h2 className="Hedingsa">International Transfers</h2>
        <p className="SetSubteag">
          Your information may be processed in India or in other countries
          where our service providers operate. We apply safeguards required by
          applicable law when information is transferred internationally.
        </p>
        <h2 className="Hedingsa">Your Rights</h2>
        <p className="SetSubteag">
          Depending on the law that applies to you, you may be able to request
          access to, correction of, or deletion of your personal information.
          To make a request, contact us at career@quarec.com.
        </p>
        <h2 className="Hedingsa">Data Retention</h2>
        <p className="SetSubteag">
          We retain personal information for as long as needed to respond to
          enquiries, assess applications, provide requested communications,
          meet legal obligations, and resolve disputes. Retention periods may
          vary by the type of information and applicable legal requirements.
        </p>
        <h2 className="Hedingsa">Changes to this Privacy Policy</h2>
        <p className="SetSubteag">
          We may update this Privacy Policy periodically to reflect changes in
          our practices or legal requirements. Any modifications will be
          effective immediately upon posting the updated Privacy Policy on our
          website.
        </p>
        <h2 className="Hedingsa">Contact Us</h2>
        <p className="SetSubteag">
          If you have any questions, concerns, or requests regarding this
          Privacy Policy or your personal information, please contact us at
          career@quarec.com.
        </p>

          <p className="SetSubteag">
            Quarec Resources Pvt. Ltd., 615, Lobby 2, Sakar-9, near Old RBI Bank
            and City Gold, Ashram Road, Ahmedabad-380006, India.
          </p>
      </div>
      <Footer />
    </>
  );
}

export default Privacypolicy;
